import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminLayoutsComponent } from './layouts/admin-layouts/admin-layouts.component';
import { SiteLayoutsComponent } from './layouts/site-layouts/site-layouts.component';
import { LoginComponent } from './pages/site/login/login.component';
import { RegisterComponent } from './pages/site/register/register.component';
import { InstructorLayoutsComponent } from './layouts/instructor-layouts/instructor-layouts.component';

const routes: Routes = [

  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path:'',
    component:SiteLayoutsComponent,
    children:[
      {
        path:'',
        redirectTo:'/home',
        pathMatch:'full'
      },
      {
        path:'',
        loadChildren:()=>import('./pages/site/site.module').then(m=>m.SiteModule)
      }
    ]
  },

  {
    path:'',
    component:AdminLayoutsComponent,
    children:[
      {
        path:'',
        redirectTo:'/admin',
        pathMatch:'full'
      },
      {
        path:'admin',
        loadChildren:()=>import('./pages/admin/admin.module').then(m=>m.AdminModule)
      }
    ]
  },


  {
    path:'',
    component:InstructorLayoutsComponent,
    children:[
      {
        path:'',
        redirectTo:'/instructor',
        pathMatch:'full'
      },
      {
        path:'instructor',
        loadChildren:()=>import('./pages/instructor/instructor.module').then(m=>m.InstructorModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
